import Em from 'ember';
export default Em.Object.extend().reopenClass({
  tryReplacement() {},
  // Called from within block
  tryReplacementWithIndex() {} // Called from the sync command
});